app.component("loginPanel", {
    templateUrl: "app/src/website/login-panel.html",
    controller: "loginPanelController",
});

app.controller("loginPanelController", [
    "$scope",
    "$window",
    "$timeout",
    "$state",
    "AuthService",
    "UserService",
    "Session",
    "AUTHENTICATION_STATE",
    "$rootScope",
    "countryConfig",
    "ENV",
    function (
        $scope,
        $window,
        $timeout,
        $state,
        AuthService,
        UserService,
        Session,
        AUTHENTICATION_STATE,
        $rootScope,
        countryConfig,
        ENV
    ) {
        $scope.AS = AuthService;
        $scope.US = UserService;
        $scope.controllerName = "loginPanelController";
        $scope.page = $state.current.name;

        // --- State Management for the Login Panel ---
        $scope.loginState = 'credentials'; // 'credentials', 'mfaVerify', 'mfaConfigStep1', 'mfaConfigStep2', 'passwordUpdate', 'lostPassword', 'resetPassword', 'contactInfo'
        $scope.panelTitle = 'Login';

        $scope.creds = {
            keepLoggedIn: true
        };
        $scope.requestSent = false;
        $scope.requestUnsuccessful = false;
        $scope.mfaParameters = {};
        $scope.secretCode = "";
        $scope.form = {};
        $scope.codeDigits = ["", "", "", "", "", ""];
        $scope.mfaPathway = "";
        $scope.countryConfig = countryConfig;
        $scope.ENVIRONMENT = ENV.ENVIRONMENT;
        $scope.AS.isProcessing = false;

        // New properties for in-panel messaging
        $scope.errorMessage = null;
        $scope.successMessage = null;


        $rootScope.stopIdleTimer();

        function clearMessages() {
            $scope.errorMessage = null;
            $scope.successMessage = null;
            $scope.requestUnsuccessful = false;
        }

        // --- View Switching Functions ---
        $scope.backToLogin = function () {
            $scope.loginState = 'credentials';
            $scope.panelTitle = 'Login';
            $scope.creds = { keepLoggedIn: true };
            $scope.requestSent = false;
            if ($scope.form.loginForm) {
                $scope.form.loginForm.$setPristine();
            }
            // Clear messages but preserve any success message from a completed action (like password reset)
            if (!$scope.successMessage) {
                clearMessages();
            }
        };

        function focusFirstVerifyBox() {
            $timeout(function () {
                var firstInput = document.querySelector("#mfa-digit-0");
                if (firstInput) {
                    firstInput.focus();
                }
            }, 200);
        }

        // --- Authentication Callback Logic ---
        function callback(creds, authEvent) {
            $scope.AS.isProcessing = false;

            switch (authEvent.authenticationState) {
                case AUTHENTICATION_STATE.waitingMFACode:
                    $scope.mfaParameters = { ...authEvent, creds };
                    $scope.panelTitle = 'Two-Factor Authentication';
                    $scope.loginState = 'mfaVerify';
                    $scope.requestSent = false;
                    $scope.codeDigits = ["", "", "", "", "", ""];
                    focusFirstVerifyBox();
                    break;

                case AUTHENTICATION_STATE.configMFA:
                    $scope.mfaParameters = { ...authEvent, creds };
                    $scope.panelTitle = 'Security Upgrade';
                    $scope.loginState = 'mfaConfigStep1';
                    break;

                case AUTHENTICATION_STATE.normal:
                    // This case is handled by the promise resolution in onSubmit
                    break;
                default:
                    break;
            }
        }

        // --- MFA and Form Logic ---
        $scope.onDigitInput = function (idx, pathway) {
            var v = $scope.codeDigits[idx] || '';
            v = v.replace(/\D/, '').substr(0, 1);
            $scope.codeDigits[idx] = v;
            $scope.mfaPathway = pathway;

            if (v && idx < $scope.codeDigits.length - 1) {
                $timeout(function () {
                    var next = document.getElementById('mfa-digit-' + (idx + 1));
                    next && next.focus();
                }, 0);
            }
        };

        $scope.clearCodeDigit = function (idx) {
            $scope.codeDigits.splice(idx, 1, "");
        };

        $scope.$watchCollection("codeDigits", digits => {
            if (digits.every(c => c && c.length === 1)) {
                if ($scope.mfaPathway === "verify") $scope.requestMFAVerify(digits.join(""));
                if ($scope.mfaPathway === "config") $scope.completeMfaConfig(digits.join(""));
            }
        });

        $scope.onCodePaste = function ($event, pathway) {
            $event.preventDefault();
            const rawEvent = $event.originalEvent || $event;
            const clipboard = rawEvent.clipboardData || window.clipboardData;
            if (!clipboard || !clipboard.getData) return;

            let text = clipboard.getData('text/plain') || clipboard.getData('Text');
            const pasted = text.replace(/\D/g, '').substr(0, 6).split('');
            if (pasted.length !== 6) return;

            for (let i = 0; i < 6; i++) {
                $scope.codeDigits[i] = pasted[i];
            }
            $scope.onDigitInput(5, pathway);
        };

        function handleSuccessfulMfa(resp) {
            $scope.AS.isProcessing = true;
            Session.create(
                resp.data.access_token,
                resp.data.expires_in,
                resp.headers("X-USER-ID")
            );

            // Check if a password change is required
            if ($scope.mfaParameters.updatePasswordRequired) {
                $scope.passwordModel = {};
                $scope.userName = $scope.mfaParameters.creds.username;
                $scope.passwordModel.pw_oldpass = $scope.mfaParameters.creds.password;
                $scope.panelTitle = 'Create New Password';
                $scope.loginState = 'passwordUpdate';

                $timeout(() => {
                    const newPasswordField = document.querySelector("#pw1");
                    if (newPasswordField) {
                        newPasswordField.focus();
                    }
                }, 200);

                // Turn off spinner since we need user input
                $scope.AS.isProcessing = false;

            } else {
                $scope.US.getUser().then(function (userResp) {
                    Session.setCurrentUser(userResp.data);
                    $state.go("welcome");
                    // Keep spinner alive during state transition
                }, function (error) {
                    $scope.errorMessage = "An error occurred while fetching your user details. Please try again.";

                    // Turn off spinner on error so the user can see the message
                    $scope.AS.isProcessing = false;
                });
            }
        }

        $scope.requestMFAVerify = function (fullCode) {
            // Guard against the auto-submit watcher and an Enter-key submit firing together.
            if ($scope.AS.isProcessing) return;
            $scope.AS.isProcessing = true;
            $scope.AS.verifyMfaCode($scope.mfaParameters.creds, $scope.csrfToken, fullCode)
                .then(function () {
                    var keepLoggedIn = $scope.mfaParameters.creds.keepLoggedIn || false;
                    return $scope.AS.exchangeForTokens(keepLoggedIn);
                })
                .then(function (tokenResponse) {
                    handleSuccessfulMfa(tokenResponse);
                })
                .catch(function (err) {
                    $scope.codeDigits = ["", "", "", "", "", ""];
                    var firstDigit = document.getElementById("mfa-digit-0");
                    if (firstDigit) firstDigit.focus();
                    $scope.requestSent = true;
                    $scope.requestUnsuccessful = true;
                    if ($scope.form.mfaVerifyForm && $scope.form.mfaVerifyForm.code) {
                        $scope.form.mfaVerifyForm.code.$setValidity("wrongMFA", false);
                    }

                    $scope.AS.isProcessing = false;
                });
        };

        $scope.backToFirstStep = function () {
            $scope.panelTitle = 'Security Upgrade';
            $scope.loginState = 'mfaConfigStep1';
        };

        $scope.mfaCodeChange = function (code) {
            if (!code) {
                if ($scope.form.mfaVerifyForm && $scope.form.mfaVerifyForm.code) {
                    $scope.form.mfaVerifyForm.code.$setValidity("wrongMFA", true);
                }
                if ($scope.form.mfaConfigForm && $scope.form.mfaConfigForm.code) {
                    $scope.form.mfaConfigForm.code.$setValidity("wrongMFA", true);
                }
            }
        };

        $scope.showMFASecond = function () {
            $scope.AS.isProcessing = true;
            $scope.AS.initialMfa($scope.csrfToken).then(function (resp) {
                $scope.panelTitle = 'Scan QR Code';
                $scope.loginState = 'mfaConfigStep2';
                $scope.secretCode = `otpauth://totp/CatTrax?secret=${resp.data.secret_code}`;
                focusFirstVerifyBox();
            }, function (error) {
                $scope.backToLogin();
                $scope.errorMessage = "We couldn't start the 2FA setup. Please try logging in again.";
            }).finally(function () {
                $scope.AS.isProcessing = false;
            });
        }

        $scope.completeMfaConfig = function (code) {
            if ($scope.AS.isProcessing) return;
            $scope.AS.isProcessing = true;
            $scope.AS.completeMfa(code, $scope.csrfToken)
                .then(
                    function (resp) {
                        $scope.successMessage = "2FA setup complete! Please log in to continue.";
                        $scope.backToLogin();
                    },
                    function (error) {
                        if ($scope.form.mfaConfigForm && $scope.form.mfaConfigForm.code) {
                            $scope.form.mfaConfigForm.code.$setValidity("wrongMFA", false);
                        }
                    }
                )
                .finally(function () {
                    $scope.AS.isProcessing = false;
                });
        };

        $scope.onSubmit = function (creds) {
            if ($scope.AS.isProcessing) return;
            document.querySelector("#login-submit").blur();
            clearMessages();
            $scope.AS.isProcessing = true;

            $scope.AS.authorize().then(function (csrfToken) {
                $scope.csrfToken = csrfToken;
                return $scope.AS.login(creds, csrfToken, callback);
            }).then(
                function () {
                    $scope.AS.isProcessing = false;
                    // Login resolved without an MFA challenge: no session was created, so tell the user.
                    if ($scope.loginState === 'credentials') {
                        $scope.errorMessage = "We couldn't log you in. Please try again.";
                    }
                },
                function (err) {
                    $scope.AS.isProcessing = false;

                    $scope.errorMessage = "The email or password you entered is incorrect.";

                    $timeout(function () {
                        var passwordField = document.querySelector("#password");
                        if (passwordField) {
                            passwordField.select();
                        }
                    }, 100);
                }
            );
        };

        $scope.showContact = function () {
            $scope.loginState = 'contactInfo';
            $scope.panelTitle = 'Contact Us';
            clearMessages();
        };

        // --- Password Reset ---
        $scope.showLostPassword = function () {
            $scope.panelTitle = 'Password Reset';
            $scope.loginState = 'lostPassword';
            clearMessages();
            $scope.requestSent = false;
        };

        function resetPasswordError() {
            $scope.requestUnsuccessful = true;
            $scope.requestSuccessful = false;
            $scope.requestSent = true;
        }

        $scope.requestPwReset = function (email) {
            if ($scope.AS.isProcessing) return;
            clearMessages();
            $scope.AS.getPasswordResetToken(email).then(
                function (response) {
                    if (response.status === 204) {
                        $scope.setPassword = {
                            email: email,
                            password: "",
                            passwordVerify: "",
                            resetCode: "",
                        };
                        $scope.requestSent = true;
                        $scope.requestSuccessful = true;
                        $scope.loginState = 'resetPassword';
                        $scope.panelTitle = 'Enter Reset Code';
                    } else {
                        resetPasswordError();
                    }
                },
                function () {
                    resetPasswordError();
                }
            );
        };

        $scope.passwordChangeNewUser = function () {
            if ($scope.US.isProcessing) return;
            clearMessages();
            $scope.US.isProcessing = true;
            $scope.US.setPassword($scope.passwordModel.password, $scope.passwordModel.pw_oldpass, $scope.userName)
                .then(
                    function (resp) {
                        $scope.US.getUser().then(function (userResp) {
                            Session.setCurrentUser(userResp.data);
                            $state.go("welcome");
                        }, function (error) {
                            $scope.errorMessage = "An error occurred fetching user details after password change.";
                        });
                    },
                    function (err) {
                        if (err) {
                            $scope.errorMessage = "An error occurred!";
                            $timeout(function () {
                                document.querySelector("#pw1").select();
                            }, 200);
                        }
                    }
                )
                .finally(function () {
                    $scope.US.isProcessing = false;
                });
        };

        $scope.passwordChange = function (resetCode, password) {
            if ($scope.AS.isProcessing) return;
            clearMessages();
            $scope.AS.resetPassword(resetCode, password, $scope.setPassword.email).then(
                function () {
                    $scope.successMessage = "Your password has been successfully reset. Please log in.";
                    $scope.backToLogin();
                },
                function () {
                    $scope.errorMessage = "The reset code or password was invalid. Please try again.";
                }
            );
        };

        // --- Keyboard and UI Helpers ---
        $scope.onKeyDown = function (event) {
            if (event.keyCode === 13) {
                document.querySelector("#login-submit").focus();
            }
        }

        $scope.onDigitKeyDown = function (keyEvent, digitIndex) {
            var BACKSPACE_KEY_CODE = 8;
            var pressed = keyEvent.which || keyEvent.keyCode;
            if (pressed === BACKSPACE_KEY_CODE) {
                var currentValue = $scope.codeDigits[digitIndex] || "";
                if (currentValue === "" && digitIndex > 0) {
                    keyEvent.preventDefault();
                    $timeout(function () {
                        var previousInput = document.getElementById("mfa-digit-" + (digitIndex - 1));
                        if (previousInput) {
                            previousInput.focus();
                        }
                    }, 0);
                }
            }
        };
    }
]);